import {
    ACCOUNT_USERS_FILTER_CATEGORY,
    ACCOUNT_USERS_PAGE,
    ACCOUNT_USERS_SORT,
    ACCOUNT_USERS_LIST_FILTER_UPDATE,

    DELETE_ACCOUNT_USERS,
    DELETE_ACCOUNT_USERS_FAILURE,
    DELETE_ACCOUNT_USERS_SUCCESS,

    FETCH_ACCOUNT_USERS,
    FETCH_ACCOUNT_USERS_FAILURE,
    FETCH_ACCOUNT_USERS_SUCCESS,
    SORT_ASC,
} from 'store/actions/types';
import paginationHelper from 'helpers/pagination';
import reducerHelper from 'helpers/reducers';
import utils from 'helpers/utils';

const initialState = {
    data: {},
    field: 'email',
    filter: {},
    filterCategory: reducerHelper.FILTER_BASIC,
    ids: [],
    loading: false,
    offset: 0,
    order: SORT_ASC,
    page: 1,
    size: 12,
    total: 0,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case DELETE_ACCOUNT_USERS:
        case FETCH_ACCOUNT_USERS:
            return Object.assign({}, state, {
                loading: true,
            });

        case FETCH_ACCOUNT_USERS_FAILURE:
            return Object.assign({}, state, {
                data: {},
                ids: [],
                loading: false,
                offset: 0,
                size: 0,
                total: 0,
            });
        case FETCH_ACCOUNT_USERS_SUCCESS:
            // Converts the Array of results to an Object based on the id.
            const convertResultsToData = utils.mapToObject(action.payload, (value) => {
                return value.id;
            });

            const newIds = action.payload.map(function (result) {
                return result.id;
            });

            return Object.assign({}, state, {
                data: Object.assign({}, state.data, convertResultsToData),
                ids: newIds,
                loading: false,
                offset: action.payload.offset,
                size: action.payload.size,
                total: parseInt(action.payload.total, 10),
            });

        case DELETE_ACCOUNT_USERS_SUCCESS:
            const { id } = action.payload;

            const deletedData = reducerHelper.removeItemFromObject(state.data, id);
            const deletedStateIds = reducerHelper.removeItemFromArrayOfStrings(state.ids, id);

            return Object.assign({}, state, {
                data: deletedData,
                ids: deletedStateIds,
                loading: false,
                total: state.total - 1,
            });

        case DELETE_ACCOUNT_USERS_FAILURE:
            return Object.assign({}, state, {
                loading: false,
            });

        case ACCOUNT_USERS_FILTER_CATEGORY:
            return Object.assign({}, state, {
                filterCategory: action.payload,
            });

        case ACCOUNT_USERS_PAGE:
            return Object.assign({}, state, {
                offset: paginationHelper.generateNewOffset(action.payload.page, state.size),
                page: action.payload.page,
            });

        case ACCOUNT_USERS_SORT:
            return Object.assign({}, state, {
                field: action.payload.field,
                order: action.payload.order,
            });

        case ACCOUNT_USERS_LIST_FILTER_UPDATE:
            const filteredValues = reducerHelper.normaliseState(initialState, action.payload);

            return Object.assign({}, state, filteredValues);
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/accountUsersReducer.js